/**
 * @generated SignedSource<<218e0f17c07e51a60037652e87c41f89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassExitSlipsFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  dueOnFrom?: any | null | undefined;
  dueOnTo?: any | null | undefined;
  includeCanceled?: boolean | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type ExitSlipAssignedLessonsQuery$variables = {
  filter?: ClassExitSlipsFilterInput | null | undefined;
  skip?: boolean | null | undefined;
};
export type ExitSlipAssignedLessonsQuery$data = {
  readonly classExitSlips?: ReadonlyArray<{
    readonly curriculumLesson: {
      readonly id: string;
      readonly target: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  }>;
};
export type ExitSlipAssignedLessonsQuery = {
  response: ExitSlipAssignedLessonsQuery$data;
  variables: ExitSlipAssignedLessonsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "CurriculumLessonNode",
  "kind": "LinkedField",
  "name": "curriculumLesson",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TargetNode",
      "kind": "LinkedField",
      "name": "target",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipAssignedLessonsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ClassExitSlipNode",
            "kind": "LinkedField",
            "name": "classExitSlips",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitSlipAssignedLessonsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ClassExitSlipNode",
            "kind": "LinkedField",
            "name": "classExitSlips",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "cf2b067d477862591ea599c8d88ac5ef",
    "id": null,
    "metadata": {},
    "name": "ExitSlipAssignedLessonsQuery",
    "operationKind": "query",
    "text": "query ExitSlipAssignedLessonsQuery(\n  $filter: ClassExitSlipsFilterInput\n  $skip: Boolean = false\n) {\n  classExitSlips(filter: $filter) @skip(if: $skip) {\n    curriculumLesson {\n      id\n      target {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d65737f4e75153990e428ef1161dbbef";

export default node;
